var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('Left',[_c('InitialStep')],1),_c('Right',[_c('Coverage')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }